import {FieldTypeKind} from '../../enum/field.type.kind';
import {EntityMananger} from './core.entity.mananger';

export function Column(type: FieldTypeKind, allowNull?: boolean, unique?: boolean, constraint?: boolean): PropertyDecorator {
    return (target: any, key: string) => {
        const metadata = EntityMananger.getEntityColumn(target.constructor.name, key);

        metadata.columnName = key;
        metadata.columnType = type;
        metadata.allowNull = allowNull;
        metadata.unique = unique;
        metadata.constraint = constraint;

        EntityMananger.registerEntityColumns(target.constructor.name, metadata);
    };
}
